export const TEXT_COLORS = [
  { id: "soft", label: "Soft", text: "#f3e8ff", muted: "#d8b4fe" },
  { id: "bright", label: "Bright", text: "#ffffff", muted: "#f5e8ff" },
  { id: "white", label: "White", text: "#ffffff", muted: "#f4f4f5" },
  { id: "amber", label: "Amber", text: "#fde68a", muted: "#fcd34d" },
] as const;

export const TEXT_SIZES = [
  { id: "sm", label: "S", ui: "13px" },
  { id: "md", label: "M", ui: "15px" },
  { id: "lg", label: "L", ui: "18px" },
] as const;

export type TextColorId = (typeof TEXT_COLORS)[number]["id"];
export type TextSizeId = (typeof TEXT_SIZES)[number]["id"];

export type UiPrefs = {
  textColor: TextColorId;
  textSize: TextSizeId;
};

const KEY = "musicforge.uiPrefs.v1";

export const DEFAULT_UI_PREFS: UiPrefs = {
  textColor: "bright",
  textSize: "md",
};

export function loadUiPrefs(): UiPrefs {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return { ...DEFAULT_UI_PREFS };
    const parsed = JSON.parse(raw) as Partial<UiPrefs>;
    const color = TEXT_COLORS.some((c) => c.id === parsed.textColor) ? parsed.textColor! : DEFAULT_UI_PREFS.textColor;
    const size = TEXT_SIZES.some((s) => s.id === parsed.textSize) ? parsed.textSize! : DEFAULT_UI_PREFS.textSize;
    return { textColor: color, textSize: size };
  } catch {
    return { ...DEFAULT_UI_PREFS };
  }
}

export function saveUiPrefs(p: UiPrefs): void {
  try {
    localStorage.setItem(KEY, JSON.stringify(p));
  } catch {
    /* */
  }
}

export function applyUiPrefs(p: UiPrefs): void {
  if (typeof document === "undefined") return;
  const root = document.documentElement;
  root.setAttribute("data-mf-text", p.textColor);
  root.setAttribute("data-mf-size", p.textSize);
  const color = TEXT_COLORS.find((c) => c.id === p.textColor) || TEXT_COLORS[1];
  const size = TEXT_SIZES.find((s) => s.id === p.textSize) || TEXT_SIZES[1];
  root.style.setProperty("--mf-text", color.text);
  root.style.setProperty("--mf-muted", color.muted);
  root.style.setProperty("--pf-text", color.text);
  root.style.setProperty("--pf-text-muted", color.muted);
  root.style.setProperty("--mf-ui", size.ui);
}
